import { h, Component } from 'preact';
import { withTranslation } from 'react-i18next';
import { AppConstant } from '../../constant/AppConstant';
import { isReattachPending, subscribeReattach, runReattach } from '../../utils/chromeIosRelayout';
import style from './style.css';

/**
 * "Tap anywhere to continue" banner for a Chrome-iOS load another app opened
 * (issue #249).
 *
 * Chrome sometimes lays such a tab out with its top under the toolbar. The
 * page cannot tell (every measurement matches a healthy load), and Chrome
 * paints nothing below the viewport in that state, so a prompt that only
 * appears when broken is impossible (tried 2026-09-22). The banner therefore
 * shows on every hand-off load until the first tap, sitting just above the
 * footer, which is inside the visible slice in both states. Any tap runs the
 * re-attach (see chromeIosRelayout) and the banner goes away; on a healthy
 * load the tap simply dismisses it. Wording is deliberately neutral so it
 * reads as an ordinary step either way.
 */
class HandoffStrip extends Component {
	state = { pending: isReattachPending() };

	componentDidMount() {
		this.unsubscribe = subscribeReattach((pending) => this.setState({ pending }));
	}

	componentWillUnmount() {
		if (this.unsubscribe) this.unsubscribe();
	}

	onClick = () => {
		runReattach(window);
	};

	render({ t }, { pending }) {
		if (!pending) return null;
		return (
			<button type="button" class={style.banner} onClick={this.onClick}>
				{t(AppConstant.HANDOFF_TAP_TO_CONTINUE)}
			</button>
		);
	}
}

export { HandoffStrip };
export default withTranslation()(HandoffStrip);
